import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../public/assets/azure-logo.png'
import _imports_1 from '../../public/assets/okta-logo.png'
import _imports_2 from '../../public/assets/tsdo-logo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-2366f9f6")

_pushScopeId("data-v-2366f9f6")
const _hoisted_1 = { style: {"height":"100%"} }
const _hoisted_2 = {
  class: "centerArea",
  style: {"display":"none"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Techapps Portal")
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  style: {"height":"20px","vertical-align":"middle"}
}
const _hoisted_6 = {
  key: 1,
  src: _imports_1,
  style: {"height":"20px","vertical-align":"middle"}
}
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Automatic Login ")
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  style: {"width":"100%","vertical-align":"middle"}
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_center = _resolveComponent("center")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_center, null, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.idps, (idp) => {
        return (_openBlock(), _createBlock(_Fragment, { key: idp }, [
          _hoisted_4,
          _createVNode("button", {
            onClick: ($event: any) => (_ctx.login(idp)),
            style: {"width":"100%","height":"30px"}
          }, [
            (idp == 'azuread')
              ? (_openBlock(), _createBlock("img", _hoisted_5))
              : _createCommentVNode("", true),
            (idp == 'okta')
              ? (_openBlock(), _createBlock("img", _hoisted_6))
              : _createCommentVNode("", true),
            _createTextVNode("   " + _toDisplayString(_ctx.capitalize(idp)) + " Login ", 1)
          ], 8, ["onClick"]),
          _hoisted_7
        ], 64))
      }), 128)),
      _hoisted_8,
      _withDirectives(_createVNode("input", {
        type: "checkbox",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.autoLogin = $event))
      }, null, 512), [
        [_vModelCheckbox, _ctx.autoLogin]
      ]),
      _hoisted_9,
      _hoisted_10,
      _hoisted_11,
      _hoisted_12
    ])
  ]))
})